<div class="card-painel--header">
  <div class="row">
    <div class="col col-auto" *ngIf="showFilter">
      <button class="btn-painel outline" type="button" (click)="openFilter = !openFilter" [class.actived]="openFilter">
        <i class="material-icons">{{ (openFilter) ? 'cancel' : 'filter_list'}}</i>
        <span [translate]="'navigation/filter'">FILTER</span>
        <span class="badge" *ngIf="indicators.indicators && indicatorFilter.areas.length">
          {{indicatorFilter.areas.length}}
        </span>
      </button>
    </div>
    <div class="col">
      <button class="btn-painel outline" (click)="openYear('new', null)">
        <i class="material-icons">add</i>
        <span [translate]="'painel-dashboard/add-year'">ADD YEAR</span>
      </button>
    </div>
    <div class="col col-auto">
      <mat-form-field>
        <input type="text" matInput [(ngModel)]="indicatorFilter.searchQuery" placeholder="{{'navigation/search' | translate}}" (change)="initComponent()">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>
</div>

<div class="card-painel--filter mb-3" *ngIf="openFilter">
  <div class="card-painel--filter--header">
    <div class="row">
      <div class="col">
        <nav>
          <button type="button" class="btn-painel branded" (click)="initComponent(); openFilter = false;" [translate]="'navigation/apply-filters'" [translate]="'navigation/apply-filters'">
            APPLY FILTERS
          </button>

          <button type="button" class="btn-painel outline" (click)="openFilter = false" [translate]="'navigation/cancel'">
            CANCEL
          </button>
        </nav>
      </div>
      <div class="col col-auto">
        <button type="button" class="btn-painel clear" (click)="clearFilter()">
          <mat-icon matSuffix>delete</mat-icon>
          <span [translate]="'navigation/clear-all'">CLEAR ALL</span>
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md">
      <dl class="card-painel--filter--item">
        <dt [translate]="'painel-cities-inner-indicators/indicatores-by-areas'">INDICATORS BY AREAS:</dt>
        <dd>
          <mat-selection-list [(ngModel)]="indicatorFilter.areas" class="checkbox-list sm">
            <mat-list-option *ngFor="let option of areas; let index = index" checkboxPosition="before" [value]="option.id">
              <span [innerHTML]="('configuration/' + option.id) | translate"></span>
            </mat-list-option>
          </mat-selection-list>
        </dd>
      </dl>
    </div>
  </div>
</div>

<div class="alert alert-warning" *ngIf="!indicators.indicators && !loading">
  <i class="icon ion-md-alert"></i>
  <span [translate]="'painel-dashboard/no-results'"> No results found </span>
</div>

<app-loading-bar *ngIf="loading"></app-loading-bar>


<div class="card-painel--table" *ngIf="!loading">
  <i class="ion ion-md-arrow-forward branded01 right" style="display:none"></i>
  <table class="table">
    <thead>
      <tr>
        <th [translate]="'painel-dashboard/indicator'"><span *ngIf="showFilter">INDICATOR</span></th>
        <th class="text-right" [translate]="'painel-dashboard/displayed'">DISPLAYED</th>
        <th *ngFor="let th of indicators.history" class="text-right hover-edit" (click)="openFullYear(th.year, th.values)">
          <span class="material-icons">edit</span>
          {{th.year}}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of indicators.indicators">
        <td>{{item.name}}</td>
        <td class="text-right displayed hover-edit" (click)="openDisplayed(getItemProfile(item.id, (indicators.history) ? indicators.history[0].values : null), item)">
          <span class="material-icons">edit</span>

          <strong *ngIf="item.unity == 'USD' || item.unity == 'Billion USD'">{{getScoreById(item.id) | number : '1.2-2'}}</strong>
          
          <strong *ngIf="item.unity != 'USD' && item.unity != 'Billion USD'">{{getScoreById(item.id) | number }}</strong>

          <em *ngIf="item.unity">{{ item.unity }}</em>
        </td>
        <td *ngFor="let profile of indicators.history" class="text-right hover-edit" (click)="openSingle(profile, profile.year, getItemProfile(item.id, profile.values), item)" [matTooltip]="getDataSourceName(item.id, profile.values)" matTooltipPosition="above">
          <span class="material-icons">edit</span>
          {{getItemProfileValue(item.id, profile.values)}}
        </td>
      </tr>
    </tbody>
  </table>
</div>